import Enums from 'utils/EnumsManager';
import { getStore } from 'utils/localStorage';

const {
  PhantomId,
  LocalStorageKeys,
} = Enums;
const { crmPageInfo } = LocalStorageKeys;

export const getPageInfo = () => (getStore(crmPageInfo) ? JSON.parse(getStore(crmPageInfo)) : {});

export const parseViewId = type => (!_.isEmpty(getPageInfo().activeViewId) && getPageInfo().activeViewId[type] ? getPageInfo().activeViewId[type] : PhantomId);

export const parseSetSorter = (state, newSorter) => {
  const objectTypeOrder = state.sorters[newSorter.objectType];
  // check if there are any sorters under newSorter.viewId
  const checkSameViewPage = objectTypeOrder.filter(sorter => sorter.viewId === newSorter.viewId);
  let setPageSorter = _.cloneDeep(objectTypeOrder);
  // if viewId match, then update the sorter of the viewId. Ortherwise, add sorter to the viewId.
  // The object of sorter include: viewId, columnId, sorter, objectType.
  if (!_.isEmpty(checkSameViewPage)) {
    setPageSorter = objectTypeOrder.map((sorter) => {
      if (sorter.viewId === newSorter.viewId) {
        return {
          ...sorter,
          ...newSorter,
        };
      }
      return sorter;
    });
  } else {
    setPageSorter.push(newSorter);
  }
  return setPageSorter;
};

export const parseGetSorter = (objectType) => {
  const pageInfo = getPageInfo();
  const sorters = !_.isEmpty(pageInfo.sorters) ? pageInfo.sorters : {};
  return _.isArray(sorters[objectType]) ? sorters[objectType] : [];
};

export const getSorter = (ViewId, sorters, objectType) => {
  if (ViewId && sorters && objectType) {
    const sorter = sorters[objectType].filter(s => s.viewId === ViewId);
    const parseSorter = {
      orderBy: !_.isEmpty(sorter) && sorter[0].orderBy ? sorter[0].orderBy : '',
      sortedBy: !_.isEmpty(sorter) && sorter[0].sortedBy ? sorter[0].sortedBy : '',
    };
    return parseSorter;
  }
  return {
    orderBy: '',
    sortedBy: '',
  };
};

export const deleteSorter = (viewId, sorters, objectType) => {
  const oldSorter = _.cloneDeep(sorters[objectType]);
  const newSorter = oldSorter.filter(sorter => Number(sorter.viewId) !== Number(viewId));
  return newSorter;
};




// WEBPACK FOOTER //
// ./src/views/ObjectList/flow/utils.js